<script>
    export default {
        name: "ProductCardIcons",
        props: {
            disabled: String,
        },
        computed: {
            icons() {
                return [
                    { name: "macos", text: "MacOS;" },
                    { name: "windows", text: "Windows;" },
                    { name: "linux", text: "Linux." },
                    { name: "android", text: "Android;" },
                    { name: "ios", text: "iOS." },
                ];
            },
        },
    };
</script>

<template>
    <div class="product-card-icons">
        <div
            class="product-card-icon"
            :class="{ 'is-disabled': disabled === icon.name }"
            v-for="icon in icons"
            :key="icon.name"
        >
            <img :src="`/static/ledger/icons/products/${icon.name}.svg`" alt="" />
            <span>{{ icon.text }}</span>
        </div>
    </div>
</template>

<style lang="scss">
    .product-card-icons {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -5px -5px;
        @include bp($bp-desktop-sm) {
            flex-direction: column;
            max-height: 115px;
            margin: 0 -10px -8px;
        }
    }

    .product-card-icon {
        display: flex;
        align-items: center;
        margin: 0 5px 5px;
        font-size: 12px;
        line-height: 18px;
        img {
            width: 20px;
            height: 20px;
            margin-right: 5px;
        }
        &.is-disabled {
            opacity: 0.2;
            text-decoration: line-through;
        }
        @include bp($bp-desktop-sm) {
            margin: 0 10px 8px;
            font-size: 18px;
            line-height: 24px;
            img {
                width: 28px;
                height: 28px;
                margin-right: 10px;
            }
        }
    }
</style>
